import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import StatusBadge from '../components/StatusBadge';
import { addPageAction } from '../newrelic';

export default function Dashboard() {
  const [health, setHealth] = useState(null);
  const [items, setItems] = useState(null);
  const [chaos, setChaos] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    addPageAction('dashboard_viewed');

    Promise.allSettled([api.getHealth(), api.getItems(), api.getChaosStatus()]).then(
      ([h, i, c]) => {
        if (h.status === 'fulfilled') setHealth(h.value);
        if (i.status === 'fulfilled') setItems(i.value);
        if (c.status === 'fulfilled') setChaos(c.value);
        setLoading(false);
      },
    );
  }, []);

  if (loading) {
    return (
      <div className="loading-center">
        <div className="spinner spinner-lg" />
      </div>
    );
  }

  const itemCount = items?.data?.length ?? 0;
  const healthStatus = health?.status ?? 'UNKNOWN';
  const chaosEnabled = chaos?.data?.enabled ?? false;

  return (
    <>
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Demo Observability App overview and quick actions</p>
      </div>

      <div className="grid-4" style={{ marginBottom: '1.5rem' }}>
        <div className="card">
          <div className="stat-label">System Health</div>
          <div style={{ marginTop: '0.5rem' }}>
            <StatusBadge status={healthStatus} />
          </div>
        </div>
        <div className="card">
          <div className="stat-label">Items</div>
          <div className="stat-value">{itemCount}</div>
        </div>
        <div className="card">
          <div className="stat-label">Chaos Mode</div>
          <div style={{ marginTop: '0.5rem' }}>
            <StatusBadge status={chaosEnabled ? 'ACTIVE' : 'INACTIVE'} />
          </div>
        </div>
        <div className="card">
          <div className="stat-label">Error Rate</div>
          <div className="stat-value">{chaos?.data?.errorRate ?? 0}%</div>
        </div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-header">
            <span className="card-title">Components</span>
            <Link to="/health" className="btn btn-outline btn-sm">
              View Details
            </Link>
          </div>
          {health?.components ? (
            <table>
              <thead>
                <tr>
                  <th>Component</th>
                  <th>Status</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(health.components).map(([name, comp]) => (
                  <tr key={name}>
                    <td style={{ fontWeight: 500 }}>{name}</td>
                    <td>
                      <StatusBadge status={comp.status} />
                    </td>
                    <td className="text-muted">{comp.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-muted">No component data available</p>
          )}
        </div>

        <div className="card">
          <div className="card-header">
            <span className="card-title">Quick Actions</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <Link to="/items" className="btn btn-primary" style={{ justifyContent: 'center' }}>
              Manage Items
            </Link>
            <Link to="/messaging" className="btn btn-outline" style={{ justifyContent: 'center' }}>
              Publish Messages
            </Link>
            <Link to="/upload" className="btn btn-outline" style={{ justifyContent: 'center' }}>
              Upload Files
            </Link>
            <Link to="/chaos" className="btn btn-warning" style={{ justifyContent: 'center' }}>
              Chaos Engineering
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
